import { twMerge } from "tailwind-merge"

import { Reaction, ReactionType } from "./Reaction"

export type ReactionStatisticsProps = {
  heartEyes: number
  partyPopper: number
  smilingFace: number
  star: number
  className?: string
  reactionClassName?: string
}

export function ReactionStatistics(props: ReactionStatisticsProps) {
  const { heartEyes, partyPopper, smilingFace, star, className, reactionClassName } = props
  return (
    <div className={twMerge("grid h-full w-full grid-cols-2 gap-x-12 gap-y-4", className)}>
      <ReactionStat
        reaction={ReactionType.HEART_EYES}
        count={heartEyes}
        className={twMerge("justify-end", reactionClassName)}
      />
      <ReactionStat reaction={ReactionType.PARTY_POPPER} count={partyPopper} className={reactionClassName} />
      <ReactionStat
        reaction={ReactionType.SMILING_FACE}
        count={smilingFace}
        className={twMerge("justify-end", reactionClassName)}
      />
      <ReactionStat reaction={ReactionType.STAR} count={star} className={reactionClassName} />
    </div>
  )
}

function ReactionStat({ reaction, count, className }: { reaction: ReactionType; count: number; className?: string }) {
  return (
    <div className={twMerge("flex items-center gap-3", className)}>
      <Reaction reaction={reaction} className="h-9 w-9" />
      <p className="text-gray-900">{count || 0}</p>
    </div>
  )
}
